import React from "react";
import { Reveal } from "@/components/Reveal";

export default function SectionHeading({ overline, title, subtitle, align = "left", className = "" }) {
  return (
    <div className={`${align === "center" ? "mx-auto text-center max-w-3xl" : "max-w-3xl"} ${className}`}>
      <Reveal><span className="overline">{overline}</span></Reveal>
      <Reveal delay={0.08}>
        <h2 className="display-mega text-4xl md:text-6xl lg:text-7xl mt-4">{title}</h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.16}>
          <p className="text-neutral-500 text-base md:text-lg mt-5 leading-relaxed normal-case tracking-normal">{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
}
